import { shadows } from "../shadows/shadows.js";
import "@mui/material";
const MuiPickersPopper = {
  styleOverrides: {
    paper: {
      borderRadius: "16px",
      boxShadow: shadows[4]
    }
  }
};
export {
  MuiPickersPopper,
  MuiPickersPopper as default
};
